// extracted by mini-css-extract-plugin
module.exports = {"htmlArea":"HtmlAreaPart_htmlArea__omPG_","redBorder":"HtmlAreaPart_redBorder__MnQe2"};